// admin-panel-frontend/src/shared/utils/contactRouteUtils.ts
export type ContactRouteType = '' | 'supplier' | 'intern';  // '' = default route context for '/members' route ('Mitglied' in ContactType)
export type ContactTypeNumber = 1 | 2 | 3;

export function getContactRouteType(path: string): ContactRouteType {
  if (path.includes('/intern')) {
    return 'intern';
  }

  if (path.includes('/supplier')) {
    return 'supplier';
  }

  return '';
}

export function getContactRouteTypeNumber(
  contactType: ContactRouteType
): number {
  switch (contactType) {
    case 'supplier':
      return 2;
    case 'intern':
      return 3;
    default:
      return 1;
  }
}
